import { pixelCustom, pixelStandard } from './metaPixel'

/**
 * Single tracking entry point for the landing page.
 * Each event is forwarded to the data layer (GTM) and to the Meta Pixel.
 */

export type TrackingEvent =
  | 'landing_page_view'
  | 'hero_cta_click'
  | 'form_start'
  | 'form_submission'
  | 'calendar_click'
  | 'calendar_booking'
  | 'phone_click'
  | 'scroll_depth'

type Payload = Record<string, string | number | boolean>

/** Meta Pixel mapping. Standard events feed Meta ad optimization and reporting. */
const pixelMap: Record<TrackingEvent, { name: string; standard: boolean }> = {
  // PageView is fired by the pixel base code on init.
  landing_page_view: { name: 'LandingPageView', standard: false },
  hero_cta_click: { name: 'HeroCtaClick', standard: false },
  form_start: { name: 'FormStart', standard: false },
  // The conversion: optimize Meta campaigns on this one.
  form_submission: { name: 'Lead', standard: true },
  calendar_click: { name: 'CalendarClick', standard: false },
  calendar_booking: { name: 'Schedule', standard: true },
  phone_click: { name: 'Contact', standard: true },
  scroll_depth: { name: 'ScrollDepth', standard: false },
}

export function track(event: TrackingEvent, payload: Payload = {}): void {
  const detail = { event, ...payload, ts: Date.now() }

  // Google Tag Manager / analytics data layer.
  const w = window as unknown as { dataLayer?: unknown[] }
  if (Array.isArray(w.dataLayer)) {
    w.dataLayer.push(detail)
  }

  // Meta Pixel.
  const mapped = pixelMap[event]
  if (mapped) {
    const pixelPayload: Record<string, unknown> = {
      content_name: 'HomeSmart NEXT Agent Growth',
      content_category: 'Agent Recruiting',
      ...payload,
    }
    if (mapped.standard) {
      pixelStandard(mapped.name, pixelPayload)
    } else {
      pixelCustom(mapped.name, pixelPayload)
    }
  }

  if (typeof console !== 'undefined') {
    console.debug('[track]', detail)
  }
}
